import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
//import App from './App.vue'
//import router from './router'
//import store from './store'
//import axios from 'axios'
//import VueAxios from 'vue-axios'
//import interceptorsSetup from './interceptors'

import decimalTextFieldPlugin from "./plugins/decimalTextFieldPlugin"
import vDecimalText from './plugins/v-decimal-text'


import { createVuetify } from 'vuetify'
import { sv } from 'vuetify/locale'

//import 'vuetify/styles'
//import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
var emitter = require('tiny-emitter/instance');


//Common components
//common-rule 
import CommonPassword from './components/common/common-password.vue'
import CommonRule from './components/common/common-rule.vue'
import CommonSpinner from './components/common/common-spinner.vue'


// Add the imported components

import CommonLabelContainer from './components/common/common-label-container.vue'
import CommonMceEditor from './components/common/common-mce-editor.vue'
import CommonLogin from './components/common/common-login.vue'
import CommonModal from './components/common/common-modal.vue'




import WorkOrganisation from './components/applications/workorganisation/work-organisation.vue'
import UpdateWorkTask     from './components/applications/workorganisation/update-worktask.vue'
import UpdateWorkPosition from './components/applications/workorganisation/update-workposition.vue'
import UpdatedevelopmentBlock from './components/applications/workorganisation/update-developmentblock.vue'

import ManageWorkpositions from './components/applications/workorganisation/manage-workpositions.vue'
import WorkContentAndDevelopment from './components/applications/workorganisation/work-content-and-development.vue'
import ManageWorktasks from './components/applications/workorganisation/manage-worktasks.vue'
import ManageDevelopmentblocks from './components/applications/workorganisation/manage-developmentblocks.vue'
import WorkOrganisationResult from './components/applications/workorganisation/work-organisation-result.vue'
//

import ModuleApp from './components/applications/module/module-app.vue'
import UpdateModule from './components/applications/module/update-module.vue'
import UpdateSubSection from './components/applications/module/update-subsection.vue'

import WageSetting from './components/applications/wagesetting/wage-setting.vue'
import WageBlockDificultyLevel from './components/applications/wagesetting/wage-block-dificulty-level.vue'
import WageBlockDificultyLevelAnalysis from './components/applications/wagesetting/wage-block-dificulty-level-analysis.vue'
import WageBlockDificultyLevelEvaluation from './components/applications/wagesetting/wage-block-dificulty-level-evaluation.vue'
import WageBlockDificultyLevelEvaluationPopup from './components/applications/wagesetting/wage-block-dificulty-level-evaluation-popup.vue'
import WageBlockUpdateGrade from './components/applications/wagesetting/update/update-block-grade.vue'
import UpdateCompetenceComment from './components/applications/wagesetting/update/update-competence-comment.vue'
import ViewCompetenceComment from './components/applications/wagesetting/update/view-competence-comment.vue'



import WageDynamicWagepart from './components/applications/wagesetting/wage-dynamic-wagepart.vue'
import WageUpdateDynamicWagepart from './components/applications/wagesetting/update/update-dynamic-wagepart.vue'

import WageEvaluateFactors from './components/applications/wagesetting/wage-evaluate-factors.vue'
import WageEvaluateReferencePositions from './components/applications/wagesetting/wage-evaluate-referencepositions.vue'
import WageEvaluateBasework from './components/applications/wagesetting/wage-evaluate-basework.vue'
import WageEvaluateAnalysis from './components/applications/wagesetting/wage-evaluate-analysis.vue'
import WageUpdateBaseFactor from './components/applications/wagesetting/update/update-base-factor.vue'
import WageUpdateBaseGrade from './components/applications/wagesetting/update/update-base-grade.vue'

import WageIndividualFactors from './components/applications/wagesetting/wage-individual-factors.vue'
import WageUpdateIndividualFactor from './components/applications/wagesetting/update/update-individual-factor.vue'
import WageUpdateIndividualGrade from './components/applications/wagesetting/update/update-individual-grade.vue'

import WageEmployeeAdmin from './components/applications/wagesetting/wage-employee-admin.vue'
import WageUpdateEmployee from './components/applications/wagesetting/update/update-employee.vue'
import WageEmployeeCompetenceMatrix from './components/applications/wagesetting/wage-employee-competence-matrix.vue'
import WageEmployeeCompetences from './components/applications/wagesetting/wage-employee-competences.vue'
import WageEmployeeDynamic from './components/applications/wagesetting/wage-employee-dynamic.vue'
import WageEmployeeIndividual from './components/applications/wagesetting/wage-employee-individual.vue'

//

import WageMoneyBaseSalary from './components/applications/wagesetting/wage-money-base-salary.vue'
import WageMoneyPositionSalary from './components/applications/wagesetting/wage-money-position-salary.vue'
import WageMoneyIndividualSalary from './components/applications/wagesetting/wage-money-individual-salary.vue'
import WageMoneyDynamicSalary from './components/applications/wagesetting/wage-money-dynamic-salary.vue'
import UpdateSalaryInterval from './components/applications/wagesetting/update/update-salary-interval.vue'


import WageResultIndividual from './components/applications/wagesetting/wage-result-individual.vue'
import WageResultLargeanalysis from './components/applications/wagesetting/wage-result-largeanalysis.vue'
import WageResultStatistics from './components/applications/wagesetting/wage-result-statistics.vue'
import WageResultTotaloverview from './components/applications/wagesetting/wage-result-totaloverview.vue'

import messages from './locales/translations.json';

import WagePositions from './components/applications/wagesetting/wage-positions.vue'

import CompetenceMain from './components/applications/competence/competence-main.vue'
import CompetenceEmployeeMultiskill from './components/applications/competence/competence-employee-multiskill.vue'

import CompetenceIndividual from './components/applications/competence/competence-individual.vue'
import CompetenceRegister from './components/applications/competence/competence-register.vue'
import CompetenceDevelopmentplan from './components/applications/competence/competence-developmentplan.vue'
import CompetenceMatrixMultiskills from './components/applications/competence/competence-matrix-multiskills.vue'
import CompetenceMatrixEducation from './components/applications/competence/competence-matrix-education.vue'
import CompetenceAdminCompetenceCategory from './components/applications/competence/competence-admin-competence-category.vue'
import UpdateCompetenceCategory2 from './components/applications/competence/update/competence-update-competence-category2.vue'
import UpdateCompetence from './components/applications/competence/update/competence-update-competence.vue'
import CompetenceEmplyeeCategoryCompetence from './components/applications/competence/competence-emplyee-category-competence.vue'
import CompetencePrintSummary from './components/applications/competence/competence-print-summary.vue'


import EqualityMain from './components/applications/equality/equality-main.vue'
import EqualityReportGenderDistribution from './components/applications/equality/equality-report-gender-distribution.vue'
import EqualityReportGenderPositionDevelopment from './components/applications/equality/equality-report-gender-position-development.vue'
import EqualityReportGenderPositionSalary from './components/applications/equality/equality-report-gender-position-salary.vue'


import AdminAnalysisCriteras from './components/applications/admin/admin-analysis-criteras.vue'
import AdminClub from './components/applications/admin/admin-club.vue'
import AdminCompanyAll from './components/applications/admin/admin-company-all.vue'
import AdminExampleCompanies from './components/applications/admin/admin-example-companies.vue'
import AdminCompanyDepartment from './components/applications/admin/admin-company-department.vue'
import AdminCompanyWorkspace from './components/applications/admin/admin-company-workspace.vue'
import AdminDepartment from './components/applications/admin/admin-department.vue'
import AdminImportData from './components/applications/admin/admin-import-data.vue'
import AdminRegisterMaintenance from './components/applications/admin/admin-register-maintenance.vue'
import AdminUsers from './components/applications/admin/admin-users.vue'
import AdminUsersAll from './components/applications/admin/admin-users-all.vue'
import UpdateUser from './components/applications/admin/update/update-user.vue'
import UpdateUserAdvanced from './components/applications/admin/update/update-user-advanced.vue'
import UpdateUserDepartment from './components/applications/admin/update/update-user-department.vue'
import AdminUsersDepartment from './components/applications/admin/admin-users-department.vue'
import AdminViewLogAll from './components/applications/admin/admin-view-log-all.vue'
import AdminViewLogCompany from './components/applications/admin/admin-view-log-company.vue'
import AdminViewLogWorkspace from './components/applications/admin/admin-view-log-workspace.vue'
import AdminViewLogDepartment from './components/applications/admin/admin-view-log-department.vue'
import AdminUpdateCompany from './components/applications/admin/update/update-company.vue'
import AdminUpdateCompanyAdvanced from './components/applications/admin/update/update-company-advanced.vue'
import AdminUpdateCompanyDepartment from './components/applications/admin/update/update-company-department.vue'

import UpdateDepartment from './components/applications/admin/update/update-department.vue'
import AdminWorkspaceAll from './components/applications/admin/admin-workspace-all.vue'
import AdminWorkspaceDepartment from './components/applications/admin/admin-workspace-department.vue'

import AdminNews from './components/applications/admin/admin-news.vue'
import AdminNewsUpdate from './components/applications/admin/update/update-news.vue'

import PotDistribution from './components/applications/pot/pot-distribution.vue'
import PotAnalysis from './components/applications/pot/pot-analysis.vue'
import PotBaseSalary from './components/applications/pot/pot-base-salary.vue'
import PotIndividualSalary from './components/applications/pot/pot-individual-salary.vue'
import PotPositionSalary from './components/applications/pot/pot-position-salary.vue'
import PotSalarySum from './components/applications/pot/pot-salary-sum.vue'
import PotTransfer from './components/applications/pot/pot-transfer.vue'
import UpdatePotSalaryInterval from './components/applications/wagesetting/update/update-pot-salary-interval.vue'

import AdminPermissions from './components/applications/admin/admin-permissions.vue'
import SuperAdminPermissions from './components/applications/admin/super-admin-permissions.vue'
//
var i18n = new createI18n({
    locale: 'sv',
    fallbackLocale: 'sv',
    messages
});

const swedishVuetifyMessages = {
    ...sv,
    input: {
        ...sv.input,
        appendAction: 'Efterställd åtgärd'
    }
}

const vuetify = createVuetify({
    components,
    directives,
    ssr: true,
    locale: {
        locale: 'sv',
        fallback: 'sv',
        messages: {
            sv: swedishVuetifyMessages
        }
    },
    icons: {
        defaultSet: 'mdi',
        aliases,
        sets: {
            mdi,
        },
    }
})



// Create an empty app
var app = createApp({
    components: {
        CommonLabelContainer,
        CommonRule,
        CommonPassword,
        CommonSpinner,
        CommonLogin,
        CommonModal,
        WorkOrganisation,
        UpdateWorkTask,
        UpdateWorkPosition,
        UpdatedevelopmentBlock,
        ManageWorkpositions,
        WorkContentAndDevelopment,
        ManageWorktasks,
        ManageDevelopmentblocks,
        WorkOrganisationResult,
        ModuleApp,
        UpdateModule,
        UpdateSubSection,
        WageSetting,
        WageBlockDificultyLevel,
        WageBlockDificultyLevelEvaluationPopup,
        WageBlockDificultyLevelAnalysis,
        WageBlockDificultyLevelEvaluation,
        WageBlockUpdateGrade,
        UpdateCompetenceComment,
        ViewCompetenceComment,
        WageDynamicWagepart,
        WageUpdateDynamicWagepart,
        WageEvaluateFactors,
        WageEvaluateReferencePositions,
        WageEvaluateBasework,
        WageEvaluateAnalysis,
        WageUpdateBaseFactor,
        WageUpdateBaseGrade,
        WageIndividualFactors,
        WageUpdateIndividualFactor,
        WageUpdateIndividualGrade,
        WageEmployeeAdmin,
        WageUpdateEmployee,
        WageEmployeeCompetenceMatrix,
        WageEmployeeCompetences,
        WageEmployeeDynamic,
        WageEmployeeIndividual, 
        WageMoneyBaseSalary,
        WageMoneyPositionSalary,
        WageMoneyIndividualSalary,
        WageMoneyDynamicSalary,
        UpdateSalaryInterval,
        WageResultLargeanalysis,
        WageResultStatistics,
        WageResultTotaloverview,
        WageResultIndividual,
        WagePositions,
        CompetenceMain,
        CompetenceIndividual,
        CompetenceRegister,
        CompetenceDevelopmentplan,
        CompetenceMatrixMultiskills,
        CompetenceMatrixEducation,
        CompetenceAdminCompetenceCategory,
        CompetencePrintSummary,
        UpdateCompetenceCategory2,
        UpdateCompetence,
        CompetenceEmplyeeCategoryCompetence,
        CompetenceEmployeeMultiskill,
        EqualityMain,
        EqualityReportGenderDistribution,
        EqualityReportGenderPositionDevelopment,
        EqualityReportGenderPositionSalary,
        AdminAnalysisCriteras,
        AdminClub,
        AdminCompanyAll,
        AdminExampleCompanies,
        AdminCompanyDepartment,
        AdminCompanyWorkspace,
        AdminDepartment,
        AdminImportData,
        AdminRegisterMaintenance,
        AdminUsers,
        AdminUsersAll,
        UpdateUser,
        UpdateUserAdvanced,
        UpdateUserDepartment,
        AdminUsersDepartment,
        AdminViewLogAll,
        AdminViewLogCompany,
        AdminViewLogWorkspace,
        AdminViewLogDepartment,
        AdminUpdateCompany,
        AdminUpdateCompanyAdvanced,
        AdminUpdateCompanyDepartment,
        UpdateDepartment,
        AdminWorkspaceAll,
        AdminWorkspaceDepartment,
        AdminNews,
        AdminNewsUpdate,
        PotDistribution,
        PotAnalysis,
        PotBaseSalary,
        PotIndividualSalary,
        PotPositionSalary,
        PotSalarySum,
        PotTransfer,
        UpdatePotSalaryInterval,
        CommonMceEditor,
        AdminPermissions,
        SuperAdminPermissions,
    },

    created: function () {
        //alert("created")
    },
    mounted: function () {
        //alert("mounted")
    },
})

app.directive('decimal-text', vDecimalText)
app.use(vuetify)
app.use(i18n)
app.use(decimalTextFieldPlugin)

//app.use(VueAxios, axios)

//Vue.prototype.$http = axios

window.emitter = emitter;

//interceptorsSetup();


// Store in the window so that we can mount it in the page
window.app = app;

//var $eventBus = new createApp({});


